export const sunsetSpecificTranslations = {
  "sunset-home-page": {
    "hero-title": "Access your existing bookings",
    "hero-description": "{brand} is no longer accepting new bookings, but your existing reservations are safe.",
    "manage-booking-title": "Manage your booking",
    "manage-booking-description": "Don’t know your booking number?",
    "manage-booking-submit": "Manage booking",
    "manage-booking-error-title": "We couldn't find your booking",
    "manage-booking-error-description":
      "Please double-check if the booking number and email address are correct. Make sure they match the details you used when booking.",
    "manage-booking-restore-action": "Find your booking",
    "manage-booking-form": {
      email: {
        title: "Email address",
      },
      "booking-number": {
        title: "Booking number",
      },
    },
    "next-stay-title": "Looking for your next stay?",
    "next-stay-description": "Explore our trusted partners' sites for new reservations",
    "next-stay-button-label": "Visit trivago.DEALS",
    "next-stay-brand-subtitle": "Find great hotel deals around the world",
  },
} as const;

export type ISunsetSpecificTranslations = typeof sunsetSpecificTranslations;

export const sunsetBrandsTranslations = sunsetSpecificTranslations;
export type ISunsetBrandsTranslations = typeof sunsetBrandsTranslations;
